// NOTE: narrow is our default formatting option and must be first-oriented
// Other should be mostly used for formatting (see `formatWeekday`)
export const DAY_NAMES_NARROW = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'] as const

export type DayNameNarrow = (typeof DAY_NAMES_NARROW)[number]

export const DAY_NAMES_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'] as const

export type DayNameShort = (typeof DAY_NAMES_SHORT)[number]

export const DAY_NAMES_LONG = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
] as const

export type DayNameLong = (typeof DAY_NAMES_LONG)[number]

export const MONTH_NAMES_LONG = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const

export type MonthNameLong = (typeof MONTH_NAMES_LONG)[number]

export const DEFAULT_TZ = 'America/Chicago'
